import React from 'react'

export default function FullCamera({ className }) {
    return (
        <svg
            className={`${className} w-8 h-8 text-[#0077ef]`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="white"
        >
            <path d="M12 12.25a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5z" />
            <path fillRule="evenodd" d="M2.25 5.5A3.25 3.25 0 015.5 2.25h13A3.25 3.25 0 0121.75 5.5v13A3.25 3.25 0 0118.5 21.75h-13A3.25 3.25 0 012.25 18.5v-13zm3.25.75a2.25 2.25 0 00-2.25 2.25v10.5a2.25 2.25 0 002.25 2.25h13a2.25 2.25 0 002.25-2.25V8.5a2.25 2.25 0 00-2.25-2.25h-13z" clipRule="evenodd" />
        </svg>
    )
}
